import {ActionList} from '@primer/react'
import {FailureDialog} from '../FailureDialog'
import {StateIcon} from '../StateIcon'
import type {DefaultError, UseMutationResult} from '@github-ui/react-query'
import {announce} from '@github-ui/aria-live'
import {useMarkReadyForReviewMutation} from '@github-ui/mergebox/use-mark-ready-for-review-mutation'
import {useOptimisticPrStateCallbacks} from '../../hooks/use-invalidate-pr-state'

const mutateOptions = {onSuccess: () => announce('Pull request marked as ready for review')}

export function useMarkReadyForReviewActionMutation() {
  return useMarkReadyForReviewMutation(useOptimisticPrStateCallbacks('OPEN'))
}

export function MarkReadyForReviewAction({mutation}: {mutation: UseMutationResult<void, DefaultError, void>}) {
  return (
    <ActionList.Item loading={mutation.isPending} onSelect={() => mutation.mutate(undefined, mutateOptions)}>
      <ActionList.LeadingVisual>
        <StateIcon state="OPEN" />
      </ActionList.LeadingVisual>
      Mark ready for review
    </ActionList.Item>
  )
}

export function MarkReadyForReviewFailureDialog({mutation}: {mutation: UseMutationResult<void, DefaultError, void>}) {
  return mutation.isError ? (
    <FailureDialog
      title="Failed to mark ready for review"
      message="An error occurred while marking this pull request as ready for review. Please try again."
      details={mutation.error.message}
      onRetry={() => mutation.mutate(undefined, mutateOptions)}
      onDismiss={() => mutation.reset()}
    />
  ) : null
}
